/* eslint-disable no-empty-pattern */
/*
 *  CampaignReadPoEditModal.jsx
 *
 *
 *
 */
//==============================================================================
// External dep.
//==============================================================================
import _ from "lodash";
import moment from "moment";
import React, { useState, useCallback } from "react";
import ReactTooltip from "react-tooltip";
import { ModalConfirm } from "@talentbait/shared-components";
//------------------------------------------------------------------------------
// Interal dep.
//------------------------------------------------------------------------------
import logger from "../../utils/LoggerFrontend";
import Actions from "../../Actions";

//------------------------------------------------------------------------------
//------------------------------------------------------------------------------
// Styles.
//------------------------------------------------------------------------------
function CampaignReadPoEditModal({ campaignId, poNumber, onUpdate = () => {} }) {
  logger.debug("CampaignReadPoEditModal", "called", {});
  const [isUpdatingPONumber, setIsUpdatingPONumber] = useState(false);
  const [currentPONumber, setCurrentPONummer] = useState(poNumber);

  const updateInvoicingDetails = () => {
    setIsUpdatingPONumber(true);

    const ref = Actions.updateCampaignInvoicePosition.completed.listen((data) => {
      logger.debug("CampaignReadPoEditModal:updateInvoicingDetails:completed", "called", {
        data,
        campaignId,
        currentPONumber,
        poNumber
      });
      setIsUpdatingPONumber(false);
      Actions.addNotification("PO Nummer aktualisiert");
      Actions.toggleModal("showGenericModal", false);
      onUpdate();

      // update campaign data as the PO Number is being updated
      Actions.loadSingleCampaign(campaignId);

      ref();
    });
    const refFailed = Actions.updateCampaignInvoicePosition.failed.listen((error) => {
      logger.log("error:CampaignReadPoEditModal:updateInvoicingDetails", "failed", {
        error,
        campaignId,
        currentPONumber,
        poNumber
      });
      Actions.addNotification("PO Nummer konnte nicht aktualisiert werden", "error");

      //* Po Number may be updated if only updating the invoicing fails

      refFailed();
    });

    Actions.updateCampaignInvoicePosition(campaignId, { poNumber: currentPONumber });
  };

  return (
    <ModalConfirm
      style={{ padding: 15 }}
      showDescription={true}
      subtitle={""}
      labelConfirm={isUpdatingPONumber ? "..." : "Aktualisieren"}
      cancelledAction={() => {
        Actions.toggleModal("showGenericModal", false);
      }}
      confirmedAction={() => {
        updateInvoicingDetails();
      }}
      description={
        <div>
          <div>
            PO Nummer:{" "}
            <input
              value={currentPONumber}
              placeholder="PO Nummer (optional)"
              onChange={(e) => {
                setCurrentPONummer(e.target.value);
              }}
            />
          </div>
        </div>
      }
    />
  );
}

export default CampaignReadPoEditModal;
